import "./loader.scss"
export class LoaderComponent extends HTMLDivElement {
  constructor() {
    super();
    this.className = 'tbw-loader'
    this.hide()
  }

  show() {
  this.style.display = 'flex'
  }

  hide() {
    this.style.display = 'none'
  }
}